import * as React from 'react'
import type { SVGProps } from 'react'
const Receipt = (props: SVGProps<SVGSVGElement>) => (
<svg xmlns="http://www.w3.org/2000/svg" width={props.width ?? "24"} height={props.height ?? "24"}  viewBox="0 0 64 64" fill="none">
  <path opacity="0.2" d="M8 52V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H54C54.5304 12 55.0391 12.2107 55.4142 12.5858C55.7893 12.9609 56 13.4696 56 14V52L48 48L40 52L32 48L24 52L16 48L8 52Z" fill="#002A73"/>
  <path d="M20 26H44" stroke="#002A73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20 34H44" stroke="#002A73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 52V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H54C54.5304 12 55.0391 12.2107 55.4142 12.5858C55.7893 12.9609 56 13.4696 56 14V52L48 48L40 52L32 48L24 52L16 48L8 52Z" stroke="#002A73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
export default Receipt

